import { abstractWalletConnector } from "@abstract-foundation/agw-react/connectors"
import type { CreateConnectorFn } from "wagmi"

export function abstractConnector() {
  return abstractWalletConnector() as CreateConnectorFn
}
